/**
 * post以及get方法的封装
 */
import request from './request'

export default {
  get (request, url, param) {
    param = param ? param : {}
    if (param.DBC) {
      url = url + '&DBC=' + param.DBC
    }
    return new Promise((resolve, reject) => {
      request.get(url, { params: param }).then(res => {
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  post (request, url, param) {
    param = param ? param : {}
    if (param.DBC) {
      url = url + '&DBC=' + param.DBC
    }
    return new Promise((resolve, reject) => {
      request.post(url, param).then(res => {
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  returnGuid (request, url) {
    return new Promise((resolve, reject) => {
      request.get(url + '/guid?OnlyTagReturn=true', {}).then(res => {
        resolve(res.data)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/utils/http.js